// Staff-side payment plan calls for one matter. Real rows or an honest
// error - no fixture fallback.

import { getAuthHeaders } from "../../../api/auth";

export interface PlanInstallment {
  amountCents: number;
  dueDate: string;
  invoiceId?: string | null;
}

export interface CasePaymentPlan {
  _id: string;
  totalCents: number;
  installments: PlanInstallment[];
  status: "active" | "completed" | "cancelled";
  issuedCount: number;
  paidCount: number;
  createdAt?: string;
}

export interface CreatePlanInput {
  totalCents: number;
  installmentCount: number;
  firstDueDate: string;
  /** Whether each part is emailed to the client when it is issued. */
  notifyClient?: boolean;
}

export async function fetchCasePlans(caseId: string): Promise<CasePaymentPlan[]> {
  const res = await fetch(`/api/cases/${caseId}/payment-plans`, {
    headers: { ...getAuthHeaders() },
    credentials: "same-origin",
  });
  if (!res.ok) throw new Error(`GET payment plans failed: ${res.status}`);
  const body = (await res.json()) as { plans: CasePaymentPlan[] };
  return body.plans;
}

export async function createPlan(caseId: string, input: CreatePlanInput): Promise<CasePaymentPlan> {
  const res = await fetch(`/api/cases/${caseId}/payment-plans`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...getAuthHeaders() },
    credentials: "same-origin",
    body: JSON.stringify(input),
  });
  const body = (await res.json().catch(() => ({}))) as {
    plan?: CasePaymentPlan;
    error?: string;
  };
  if (!res.ok || !body.plan) {
    throw new Error(body.error ?? `Create plan failed: ${res.status}`);
  }
  return body.plan;
}

export async function cancelPlan(planId: string): Promise<void> {
  const res = await fetch(`/api/payment-plans/${planId}/cancel`, {
    method: "POST",
    headers: { ...getAuthHeaders() },
    credentials: "same-origin",
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error ?? `Cancel failed: ${res.status}`);
  }
}
